import { DelegationListener } from 'inter-extension-control/module/src/delegationListener';
import { delegationCallbacks } from './delegationCallbacks';

// ID of the Linewize extension
const LINEWIZE_EXTENSION_ID = 'ifinpabiejbjobcphhaomiifjibpkjlf';

/**
 * Starts listening for delegation actions to execute callbacks
 */
export const startListeningDelegationActions = (
  initializeData: () => Promise<void>
): DelegationListener =>
  new DelegationListener(
    [LINEWIZE_EXTENSION_ID],
    delegationCallbacks,
    initializeData
  );
